import { Box, ImageListItem } from '@mui/material';
import Pagination from 'components/controls/Pagination';
import isEmpty from 'lodash/isEmpty';
import { object, number, arrayOf } from 'prop-types';
import attachmentShape from 'shapes/attachment';
import React, { Component } from 'react';
import MediaGrid from './MediaGrid';
import connector from './connector';
import VideoTile from './tile/VideoTile';
import PictureTile from './tile/PictureTile';

const MEDIA_PER_PAGE = 30;

class Documents extends Component {
  state = {
    page: 0,
  };

  componentDidMount() {
    const { actions } = this.props;
    const { page } = this.state;

    actions.media.media(page + 1, MEDIA_PER_PAGE);
  }

  changePage = ({ selected: page }) => {
    const { actions } = this.props;
    this.setState({ page });

    actions.media.media(page + 1, MEDIA_PER_PAGE);
  };

  render() {
    const { media, total } = this.props;
    const { page } = this.state;

    if (isEmpty(media)) return null;

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        <MediaGrid>
          {media.map(m => (
            <ImageListItem key={m._id}>
              {m.mimeType.includes('video') ? <VideoTile video={m} /> : <PictureTile picture={m} />}
            </ImageListItem>
          ))}
        </MediaGrid>
        <Pagination perPage={MEDIA_PER_PAGE} total={total} page={page} onChange={this.changePage} />
      </Box>
    );
  }
}

Documents.propTypes = {
  media: arrayOf(attachmentShape).isRequired,
  total: number.isRequired,
  actions: object.isRequired,
};
export default connector(Documents);
